var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ESAPI from "node-esapi";
import { loadDataForMap, onSwitchWmsButton, resetWmsLayer, switchWms, } from "./map_02";
import { itemGraph, loadDataForItemGraph, loadDataForMapAndGraph, onCloseItemGraphButton, onSwitchItemGraphButton, wipeGraph, } from "./graph_02";
import { DEFAULT_REFERENCIAL, DEFAULT_TEMPORALITY, DEFAULT_CURRENT_DATE, DEFAULT_CROP, DEFAULT_INDICATOR, DEFAULT_YEAR_MIN, RS_DEFAULT_YEAR_MIN, STATBEL_DEFAULT_YEAR_MIN, STATBEL_SURF_DEFAULT_YEAR_MIN, STATBEL_LAST_LOADED_YEAR, SEL_CROPS, SEL_METEO_SENSORS, SEL_TEMPORALITY, } from "./constants_02";
// const DEFAULT_REFERENCIAL: string = "abs"; // 'abs' || 'rel'
// const DEFAULT_TEMPORALITY: string = "YR"; // 'YR' || 'DC' || 'MO'
// const DEFAULT_CURRENT_DATE: Date = new Date();
// const DEFAULT_CROP: number = 1; // Froment d'hiver;
// const DEFAULT_INDICATOR: string = "00RNYR_CURR";
// export const DEFAULT_YEAR_MIN: number = 1991;
// const RS_DEFAULT_YEAR_MIN: number = 2014;
// const STATBEL_DEFAULT_YEAR_MIN: number = 1968;
// const STATBEL_SURF_DEFAULT_YEAR_MIN: number = 1980;
// const STATBEL_LAST_LOADED_YEAR: number = 2022;
/**
 * Initialize current values
 */
var AutoYearRangeVal = true;
export var CROPS = {};
export var currentCrop = 0;
export var currentIndicator = DEFAULT_INDICATOR;
export var currentRa = "";
export var currentReferencial = DEFAULT_REFERENCIAL;
export var currentTemporality = DEFAULT_TEMPORALITY;
export var curr_lang = (document.getElementById("current_language")).textContent;
export var INDICATORS_PARAMS = {};
// let overlay;
export var referenceDate = new Date();
export var REGIONS_AGRICOLES = {};
var capitalize = function (str) {
    return str[0].toUpperCase() + str.slice(1);
};
/**
 * Create table from object or array
 */
export var createTableFmObject = function (data) {
    var table = document.createElement("table");
    var header = document.createElement("tr");
    var keys = Object.keys(data[0]);
    table.classList.add("table");
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var th = document.createElement("th");
        th.appendChild(document.createTextNode(key));
        header.appendChild(th);
    }
    table.appendChild(header);
    for (var _a = 0, data_1 = data; _a < data_1.length; _a++) {
        var row = data_1[_a];
        var tr = document.createElement("tr");
        for (var _b = 0, keys_2 = keys; _b < keys_2.length; _b++) {
            var key = keys_2[_b];
            var td = document.createElement("td");
            var content = row[key] || "";
            td.appendChild(document.createTextNode(content));
            tr.appendChild(td);
        }
        table.appendChild(tr);
    }
    return table;
};
/**
 * Convert a Date JS object into a doy numeric value
 */
var dateToDoy = function (date) {
    var start = new Date(date.getFullYear(), 0, 0);
    var diff = +date - +start;
    var oneDay = 1000 * 60 * 60 * 24;
    var doy = Math.floor(diff / oneDay);
    return doy;
};
export var dateToDecade = function (date) {
    return date.getMonth() * 3 + Math.min(Math.ceil(date.getDate() / 10), 3);
};
var decadeToDate = function (year, decade) {
    /** You can check this decade conversion here
     * for (let d = 1; d <= 36; d++) {
     *     let month = Math.ceil(d/3);
     *     let day = ((d - (month - 1) * 3) - 1 ) * 10 + 1);
     * }
     **/
    var month = Math.ceil(decade / 3);
    var day = (decade - (month - 1) * 3 - 1) * 10 + 10; // We add 10 days to be rather at the end of the decade
    var newDate = new Date(year, month - 1, day, 3);
    if (day > 20) {
        /**
         * if we have the third decade of a month get the last day of the month
         * NB this is equal to day 0 of the following one
         */
        newDate = new Date(year, month, 0, 3);
    }
    return newDate;
};
var formatDateForInput = function (date) {
    return date.toISOString().split("T")[0];
};
export var formatReferenceDecade = function () {
    var decadeString = gettext("decade");
    var decadeNumberByMonth = Math.min(Math.ceil(referenceDate.getDate() / 10), 3);
    var decadeNumber = referenceDate.getMonth() * 3 + decadeNumberByMonth;
    var monthLength = new Date(getCurrentYear(), referenceDate.getMonth() + 1, 0).getDate();
    var startDecadeDate = decadeNumberByMonth === 1 ? 1 : decadeNumberByMonth === 2 ? 11 : 21;
    var endDecadeDate = decadeNumberByMonth === 1
        ? 10
        : decadeNumberByMonth === 2
            ? 20
            : monthLength;
    return "".concat(decadeString, " ").concat(decadeNumber, " (").concat(startDecadeDate, " - ").concat(endDecadeDate, " ").concat(formatReferenceMonth(), ")");
};
export var formatReferenceDecadeShort = function () {
    var decadeString = "decade";
    var decadeNumberByMonth = Math.min(Math.ceil(referenceDate.getDate() / 10), 3);
    var decadeNumber = referenceDate.getMonth() * 3 + decadeNumberByMonth;
    var monthLength = new Date(getCurrentYear(), referenceDate.getMonth() + 1, 0).getDate();
    var startDecadeDate = decadeNumberByMonth === 1 ? "01" : decadeNumberByMonth === 2 ? "11" : "21";
    var endDecadeDate = decadeNumberByMonth === 1
        ? "10"
        : decadeNumberByMonth === 2
            ? "20"
            : "".concat(monthLength);
    return "".concat(decadeString).concat(decadeNumber, "-").concat(formatReferenceYearMonth()).concat(startDecadeDate, "-").concat(endDecadeDate);
};
export var formatReferenceMonth = function () {
    return "".concat(referenceDate.toLocaleString("default", { month: "long" }));
};
export var formatReferenceMonthDay = function () {
    return "".concat(referenceDate.getDate(), " ").concat(formatReferenceMonth());
};
export var formatReferenceYearMonth = function () {
    return "".concat(getCurrentYear()).concat(referenceDate.toLocaleString("default", {
        month: "2-digit",
    }));
};
export var formatReferenceYearMonthDay = function () {
    return "".concat(getCurrentYear()).concat(referenceDate.toLocaleString("default", {
        month: "2-digit",
    })).concat(referenceDate.toLocaleString("default", {
        day: "2-digit",
    }));
};
/**
 * Utility function to get the base URL we are on.
 */
var getBaseURL = function () {
    var getUrl = window.location;
    return (getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split("/")[1]);
};
export var BCGMS_API_URL = "".concat(getBaseURL(), "/api/bcgms/");
var getCurrentCropLabel = function () {
    return currentCrop === 0
        ? SEL_CROPS["name_".concat(curr_lang)]
        : CROPS[currentCrop]["name_".concat(curr_lang)];
};
var getCurrentDate = function () {
    return new Date(document.getElementById("dateInput").value);
};
export var getCurrentDoy = function () { return dateToDoy(getCurrentDate()); };
var getCurrentIndicatorIRM = function () {
    return isIRMindicatorGeneric(currentIndicator)
        ? currentIndicator
        : "".concat(currentIndicator, " (").concat(getCurrentCropLabel(), ")");
};
export var getCurrentProvider = function () {
    return document.getElementById("providerInput").value;
};
var getCurrentTemporality = function () {
    return currentTemporality === "MO"
        ? SEL_TEMPORALITY["MO"]["name_".concat(curr_lang)]
        : currentTemporality === "DC"
            ? SEL_TEMPORALITY["DC"]["name_".concat(curr_lang)]
            : SEL_TEMPORALITY["YR"]["name_".concat(curr_lang)];
};
export var getCurrentYear = function () {
    var currentYear = 0;
    var value = new Date(document.getElementById("dateInput").value);
    if (value instanceof Date) {
        currentYear = value.getFullYear();
    }
    return currentYear;
};
export var getIndicatorDescription = function (indicator) {
    return INDICATORS_PARAMS[indicator]["description_" + curr_lang];
};
export var getIndicatorLabel = function (indicator) {
    if (currentReferencial === "rel" && currentRa === "") {
        // return `${INDICATORS_PARAMS[indicator]["name_" + curr_lang]} %`;
        return "%";
    }
    else {
        // return `${INDICATORS_PARAMS[indicator]["name_" + curr_lang]} ${
        //   INDICATORS_PARAMS[indicator].unit
        // }`;
        return "".concat(INDICATORS_PARAMS[indicator].unit);
    }
};
var getIndicatorMSValue = function () {
    var indmsval = "";
    if (getCurrentProvider() === "IRM") {
        var indicatorMSInput = (document.querySelector("select#indicatorMSInput"));
        indmsval = indicatorMSInput.value;
    }
    else {
        indmsval = "ALL";
    }
    return indmsval;
};
export var getRegionAgricoleLabel = function (ra) {
    return "".concat(REGIONS_AGRICOLES[ra]["name_" + curr_lang]);
};
export var getRegionAgricoleCode = function (ra) {
    return "".concat(REGIONS_AGRICOLES[ra]["code"]);
};
export var getYearMax = function () {
    return Number(document.querySelector("div.year_range input#yearMax")
        .value);
};
export var getYearMin = function () {
    return Number(document.querySelector("div.year_range input#yearMin")
        .value);
};
var hideCropSelector = function () {
    document.querySelector("div.crop_selector").classList.add("d-none");
};
var hideCultureSelector = function () {
    document.getElementById("cultureSelector").classList.add("d-none");
};
var hideDateSelector = function () {
    document.querySelector("div.date_selector").classList.add("d-none");
};
var hideDecadeSelector = function () {
    if (getCurrentProvider() === "IRM" || getCurrentProvider() === "RS") {
        document.querySelector("div.decade_selector").classList.add("d-none");
    }
};
export var hideLoaderBox = function () {
    var loaderBox = document.querySelector("div.panel__loader");
    loaderBox.classList.add("d-none");
    var dataBadgeBox = document.querySelector("div.data-badge");
    dataBadgeBox.classList.remove("d-none");
};
var hideMonthSelector = function () {
    if (getCurrentProvider() === "IRM") {
        document.querySelector("div.month_selector").classList.add("d-none");
    }
};
var hideTemporalitySelector = function () {
    if (getCurrentProvider() === "IRM") {
        (document.querySelector("div.temporality_selector")).classList.add("d-none");
    }
};
export var hideVariabilitySelector = function () {
    if (getCurrentProvider() === "IRM" || getCurrentProvider() === "RS") {
        var vitems = document.querySelectorAll("div.variability_selector");
        vitems.forEach(function (item) {
            item.classList.add("d-none");
        });
        //show the referencial selector as it become useful again
        (document.querySelector("div.referencial_selector")).classList.remove("d-none");
    }
};
var hideYearRange = function () {
    if (getCurrentProvider() === "STATBEL") {
        var yearRange = document.querySelector("div.year_range");
        yearRange.classList.add("d-none");
        // if there was a user selection, reset to defaults
        if (AutoYearRangeVal === false) {
            AutoYearRangeVal = true;
            initYearSelector();
            initDecadeSelector();
            initMonthSelector();
            initDateSelector();
            /**
             * Update graph and map for the selected indicator
             */
            updateMapAndGraph();
        }
    }
};
var hideYearSelector = function () {
    document.querySelector("div.year_selector").classList.add("d-none");
};
export var initCropSelector = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cropInput_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(getCurrentProvider() != "RS")) return [3 /*break*/, 2];
                cropInput_1 = document.getElementById("cropInput");
                cropInput_1.addEventListener("change", onSelectCrop);
                /**
                 * Remove all present elements
                 */
                while (cropInput_1.firstChild) {
                    cropInput_1.removeChild(cropInput_1.lastChild);
                }
                /**
                 * Retrieve all cultures linked to the selected year and provider
                 */
                return [4 /*yield*/, fetch("".concat(BCGMS_API_URL, "available-crops/?year=").concat(getCurrentYear(), "&provider=").concat(getCurrentProvider(), "&refdate=").concat(formatDateForInput(getCurrentDate())))
                        .then(function (response) { return response.json(); })
                        .then(function (data) {
                        /**
                         * Rebuild the selector
                         */
                        for (var _i = 0, _a = Object.entries(CROPS); _i < _a.length; _i++) {
                            var _b = _a[_i], k = _b[0], v = _b[1];
                            if (data.results.includes(Number(k))) {
                                // const option = document.createElement("option");
                                var option = document.createElement("input");
                                option.type = "radio";
                                option.classList.add("form-check-input");
                                option.id = "cropid-" + k;
                                option.name = "cropInput";
                                option.autocomplete = "off";
                                option.checked = k === "1" ? true : false;
                                option.value = k;
                                option.setAttribute("cropid", k);
                                cropInput_1.append(option);
                            }
                        }
                        /**
                         * define the selected value by default
                         */
                        if (!data.results.includes(Number(currentCrop))) {
                            switch (getCurrentProvider()) {
                                case "FCST":
                                case "STATBEL":
                                    // set current crop to DEFAULT_CROP only for STATBEL
                                    currentCrop = DEFAULT_CROP;
                                    break;
                                case "IRM":
                                case "RS":
                                default:
                                    currentCrop = 0;
                                    /**
                                     * init the cultureToggle
                                     */
                                    var cultureToggle = (document.getElementById("cultureToggle"));
                                    cultureToggle.addEventListener("change", onSelectCulture);
                                    if (currentCrop === 0) {
                                        (document.getElementById("allcultures")).checked = true;
                                        hideCultureSelector();
                                    }
                                    else {
                                        document.getElementById("culture").checked =
                                            true;
                                        showCultureSelector();
                                    }
                                    break;
                            }
                        }
                    })];
            case 1:
                /**
                 * Retrieve all cultures linked to the selected year and provider
                 */
                _a.sent();
                cropInput_1.value = currentCrop.toString();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export var initDateSelector = function () {
    /**
     * FIXME there should be an influence of the yearMax range on this
     * not easy to define
     */
    var dateInput = document.getElementById("dateInput");
    dateInput.addEventListener("change", onSelectDate);
    var minValue = set1stJanuaryDateFromYear(DEFAULT_YEAR_MIN);
    var maxValue = DEFAULT_CURRENT_DATE;
    if (getCurrentProvider() === "STATBEL") {
        minValue = set1stJanuaryDateFromYear(getYearMin());
        maxValue = set1stJanuaryDateFromYear(STATBEL_LAST_LOADED_YEAR);
    }
    var yearRange = Array.from({ length: maxValue.getFullYear() - minValue.getFullYear() + 1 }, function (_, i) { return i + minValue.getFullYear(); });
    if (!yearRange.includes(Number(getCurrentYear()))) {
        dateInput.value = formatDateForInput(maxValue);
    }
    dateInput.max = formatDateForInput(maxValue);
    dateInput.min = formatDateForInput(minValue);
    if (getCurrentProvider() === "IRM" && currentTemporality === "YR") {
        showDateSelector();
    }
    else {
        hideDateSelector();
    }
};
export var initDecadeSelector = function () {
    if (getCurrentProvider() === "RS" || getCurrentProvider() === "IRM") {
        var decadeInput = (document.getElementById("decadeInput"));
        decadeInput.addEventListener("change", onSelectDecade);
        decadeInput.addEventListener("input", setDecadeRangeValue);
        var minValue = 1;
        var maxValue = getCurrentYear() === new Date().getFullYear()
            ? dateToDecade(new Date())
            : 36;
        var currentValue = dateToDecade(getCurrentDate());
        decadeInput.min = minValue.toString();
        decadeInput.max = maxValue.toString();
        decadeInput.value = currentValue.toString();
        setDecadeRangeValue();
        if (getCurrentProvider() === "RS" ||
            (getCurrentProvider() === "IRM" && currentTemporality === "DC")) {
            showDecadeSelector();
            // change the input date to the selected decade
            var dateInput = document.getElementById("dateInput");
            var decadeDate = decadeToDate(getCurrentYear(), currentValue);
            dateInput.value = formatDateForInput(decadeDate);
        }
        else {
            hideDecadeSelector();
        }
    }
};
export var initIndicatorMSSelect = function () {
    /**
     * Initialize meteo_sensor preselector of indicators
     */
    if (getCurrentProvider() === "IRM") {
        var indicatorMSInput = (document.querySelector("select#indicatorMSInput"));
        indicatorMSInput.addEventListener("change", onSelectMSIndicator);
        for (var _i = 0, _a = Object.entries(SEL_METEO_SENSORS); _i < _a.length; _i++) {
            var _b = _a[_i], k = _b[0], v = _b[1];
            var option = document.createElement("option");
            option.value = k;
            option.innerText = v["name_".concat(curr_lang)];
            indicatorMSInput.append(option);
        }
    }
};
export var initIndicatorSelect = function () {
    /**
     * Initialize selector of indicators
     */
    var indicatorInput = (document.querySelector("select#indicatorInput"));
    indicatorInput.addEventListener("change", onSelectIndicator);
    /**
     * add 2 variables to manage currentIndicator selection
     */
    var selectedIndicator = "";
    var currentIsSelected = false;
    /**
     * Remove all existing indicators
     */
    while (indicatorInput.firstChild) {
        indicatorInput.removeChild(indicatorInput.lastChild);
    }
    /**
     * Rebuild the list in function of current provider, temporality, crop and
     * indicatorMSInput
     */
    var i = 0;
    for (var _i = 0, _a = Object.entries(INDICATORS_PARAMS); _i < _a.length; _i++) {
        var _b = _a[_i], k = _b[0], v = _b[1];
        if (v.provider === getCurrentProvider() &&
            (v.temporality === "" ||
                v.temporality === null ||
                v.temporality === currentTemporality) &&
            (getCurrentProvider() === "IRM"
                ? (v.crop_id === undefined && Number(currentCrop) === 0) ||
                    Number(v.crop_id) === Number(currentCrop)
                : true) &&
            (getIndicatorMSValue() === "ALL" ||
                v.code.substring(2, 4) === getIndicatorMSValue())) {
            if (i === 0) {
                /**
                 * If the currentindicator is not in the list, use the first one
                 * available
                 */
                selectedIndicator = k;
            }
            var option = document.createElement("option");
            option.setAttribute("id", k);
            option.value = k;
            option.innerText = v["name_".concat(curr_lang)];
            if (k === currentIndicator) {
                option.selected = true;
                currentIsSelected = true;
            }
            indicatorInput.append(option);
            i = i + 1;
        }
    }
    if (currentIsSelected === false) {
        currentIndicator = selectedIndicator;
    }
    if (i === 0) {
        setMessageBox(gettext("Pas d'indicateur pour cette combinaison d'année et de culture"));
        /**
         * FIXME effacer le graphique pré-existant.
         */
        //wipeGraph();
    }
    initYearSelector();
};
export var initMonthSelector = function () {
    if (getCurrentProvider() === "IRM") {
        var monthInput = document.getElementById("monthInput");
        monthInput.addEventListener("change", onSelectMonth);
        monthInput.addEventListener("input", setMonthRangeValue);
        var minValue = 1;
        var maxValue = getCurrentYear() === new Date().getFullYear()
            ? new Date().getMonth() + 1
            : 12;
        var currentValue = getCurrentDate().getMonth() + 1;
        monthInput.min = minValue.toString();
        monthInput.max = maxValue.toString();
        monthInput.value = currentValue.toString();
        setMonthRangeValue();
        if (getCurrentProvider() === "IRM" && currentTemporality === "MO") {
            showMonthSelector();
            // change the input date to the last day of the selected month
            var dateInput = document.getElementById("dateInput");
            var lastDayOfMonthDate = new Date(getCurrentYear(), currentValue, 0, 3);
            dateInput.value = formatDateForInput(lastDayOfMonthDate);
        }
        else {
            hideMonthSelector();
        }
    }
};
export var initProviderSelector = function () {
    var providerInput = (document.getElementById("providerInput"));
    /* add onchange event */
    providerInput.addEventListener("change", onSelectProvider);
    var closeItemGraphWrapper = document.getElementById("closeItemGraphWrapper");
    var switchItemGraph = document.getElementById("switchItemGraph");
    switch (getCurrentProvider()) {
        case "IRM":
            /* init the event for temporality selector only for meteo */
            var temporalityInput = document.getElementById("temporalityInput");
            temporalityInput.addEventListener("change", onSelectTemporality);
            document.getElementById(currentTemporality).checked =
                true;
            closeItemGraphWrapper.addEventListener("click", onCloseItemGraphButton);
            switchItemGraph.addEventListener("change", onSwitchItemGraphButton);
            hideVariabilitySelector();
            break;
        case "RS":
            closeItemGraphWrapper.addEventListener("click", onCloseItemGraphButton);
            switchItemGraph.addEventListener("change", onSwitchItemGraphButton);
            switchWms.addEventListener("change", onSwitchWmsButton);
            hideVariabilitySelector();
            break;
        case "STATBEL":
            setYearMin(DEFAULT_YEAR_MIN);
            var AutoYearRange = (document.getElementById("AutoYearRange"));
            AutoYearRange.addEventListener("change", onClickAutoYearRange);
            AutoYearRange.checked = AutoYearRangeVal;
            var yearMin = document.getElementById("yearMin");
            yearMin.addEventListener("change", onChangeYearRange);
            var yearMax = document.getElementById("yearMax");
            yearMax.addEventListener("change", onChangeYearRange);
            break;
        case "FCST":
        default:
            break;
    }
};
export var initYearSelector = function () {
    var yearInput = document.getElementById("yearInput");
    /* add events */
    yearInput.addEventListener("change", onSelectYear);
    yearInput.addEventListener("input", setYearSelectorValue);
    var minValue = DEFAULT_YEAR_MIN;
    var maxValue = DEFAULT_CURRENT_DATE.getFullYear();
    switch (getCurrentProvider()) {
        case "FCST":
            minValue = DEFAULT_CURRENT_DATE.getFullYear();
            maxValue = DEFAULT_CURRENT_DATE.getFullYear();
            break;
        case "IRM":
            break;
        case "RS":
            minValue = RS_DEFAULT_YEAR_MIN;
            maxValue = DEFAULT_CURRENT_DATE.getFullYear();
            break;
        case "STATBEL":
            maxValue = STATBEL_LAST_LOADED_YEAR;
            switch (currentIndicator) {
                case "production":
                case "surface":
                    minValue = STATBEL_SURF_DEFAULT_YEAR_MIN;
                    break;
                default:
                    minValue = STATBEL_DEFAULT_YEAR_MIN;
                    break;
            }
            /**
             * take into account user choice for year range
             */
            minValue = AutoYearRangeVal ? minValue : Math.max(minValue, getYearMin());
            maxValue = AutoYearRangeVal ? maxValue : Math.min(maxValue, getYearMax());
            /**
             * modify year range selectors
             */
            setYearMin(minValue);
            setYearMax(maxValue);
            var yearRangeMin = (document.querySelector("div.year_range input#yearMin"));
            var yearRangeMax = (document.querySelector("div.year_range input#yearMax"));
            yearRangeMin.max = getYearMax().toString();
            yearRangeMax.min = getYearMin().toString();
            break;
        default:
            break;
    }
    /**
     * modify year selector
     */
    var currentValue = getCurrentYear() === 0
        ? maxValue
        : Math.max(minValue, Math.min(maxValue, getCurrentYear()));
    yearInput.min = minValue.toString();
    yearInput.max = maxValue.toString();
    yearInput.value = currentValue.toString();
    /**
     * modify date selector accordingly
     */
    var dateInput = document.getElementById("dateInput");
    var currentDate = new Date(document.getElementById("dateInput").value);
    dateInput.value = new Date(currentDate.setFullYear(currentValue))
        .toISOString()
        .split("T")[0];
    setYearSelectorValue();
};
var isIRMindicatorGeneric = function (indicator) {
    return indicator.startsWith("00");
};
/*
 * event listeners
 */
export var onChangeYearRange = function (e) {
    // from now on the choices of the user are priority
    var AutoYearRange = (document.getElementById("AutoYearRange"));
    AutoYearRangeVal = false;
    AutoYearRange.checked = AutoYearRangeVal;
    initYearSelector();
    initDecadeSelector();
    initMonthSelector();
    initDateSelector();
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
};
var onClickAutoYearRange = function (e) {
    // reset auto values
    if (AutoYearRangeVal === false) {
        AutoYearRangeVal = true;
        initYearSelector();
        initDecadeSelector();
        initMonthSelector();
        initDateSelector();
        /**
         * Update graph and map for the selected indicator
         */
        updateMapAndGraph();
    }
    else {
        AutoYearRangeVal = false;
    }
};
var onSelectCrop = function (e) {
    currentCrop = Number(e.target.getAttribute("cropid"));
    // JPH 2024-02-22 moved to onSelectCulture event
    // if (getCurrentProvider() === "IRM") {
    //   if (Number(currentCrop) === 0) {
    //     showTemporalitySelector();
    //   } else {
    //     hideTemporalitySelector();
    //     currentTemporality = "YR";
    //     (<HTMLInputElement>document.getElementById(currentTemporality)).checked =
    //       true;
    //   }
    // }
    // initDecadeSelector();
    // initMonthSelector();
    // initDateSelector();
    initIndicatorSelect();
    updateMapAndGraph();
};
var onSelectCulture = function (e) {
    /**
     * Toggle between all cultures or display culture list
     */
    if (e.target.value === "allcultures") {
        currentCrop = 0;
        hideCultureSelector();
        showTemporalitySelector();
    }
    else {
        currentCrop = DEFAULT_CROP;
        hideTemporalitySelector();
        currentTemporality = "YR";
        document.getElementById(currentTemporality).checked =
            true;
        showCultureSelector();
    }
    // Refresh display
    initDecadeSelector();
    initMonthSelector();
    initDateSelector();
    initCropSelector().then(initIndicatorSelect).then(updateMapAndGraph);
};
var onSelectDate = function (e) {
    // update year selector based on the date
    var year = Number(new Date(e.target.value).getFullYear());
    var yearInput = document.getElementById("yearInput");
    yearInput.value = year.toString();
    setYearSelectorValue();
    if (getCurrentProvider() != "STATBEL") {
        initCropSelector();
    }
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
};
export var onSelectDecade = function (e) {
    // update date selector based on the decade
    var decade = Number(e.target.value);
    var dateInput = document.getElementById("dateInput");
    var yearInput = document.getElementById("yearInput");
    var newDate = decadeToDate(Number(yearInput.value), decade);
    dateInput.value = formatDateForInput(newDate);
    referenceDate = newDate;
    setDecadeRangeValue();
    if (getCurrentProvider() != "STATBEL") {
        initCropSelector();
    }
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
};
var onSelectIndicator = function (e) {
    var _a;
    var seloption = e.target.options[e.target.selectedIndex];
    currentIndicator = (_a = seloption.getAttribute("id")) !== null && _a !== void 0 ? _a : DEFAULT_INDICATOR;
    initYearSelector();
    /**
     * Reset the layers of the map (FIXME maybe not needed)
     */
    resetWmsLayer();
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
};
var onSelectMSIndicator = function (e) {
    initIndicatorSelect();
    updateMapAndGraph();
};
var onSelectMonth = function (e) {
    // update date selector based on the month
    var month = Number(e.target.value);
    var yearInput = document.getElementById("yearInput");
    var dateInput = document.getElementById("dateInput");
    var lastDayOfMonthDate = new Date(Number(yearInput.value), month, 0, 3);
    dateInput.value = formatDateForInput(lastDayOfMonthDate);
    setMonthRangeValue();
    if (getCurrentProvider() != "STATBEL") {
        initCropSelector();
    }
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
};
/**
 * FIXME Modifier le fonctionnement pour recharger la bonne page
 *
 * <a class="dropdown-item" href="/indicators/meteo/" title="meteo" role="menuitem">
        Meteo
      </a><a class="dropdown-item" href="/indicators/remotesensing/" title="remote_sensing" role="menuitem">
        Remote sensing
      </a><a class="dropdown-item" href="/indicators/statistics/" title="statistics" role="menuitem">
        Statistics
      </a><a class="dropdown-item" href="/indicators/forecasts/" title="forecasts" role="menuitem">
        Forecasts
      </a>
 */
export var onSelectProvider = function (e) {
    var nexturl = "";
    switch (e.target.value) {
        case "FCST":
            nexturl = "/indicators/forecasts/";
            break;
        case "STATBEL":
            nexturl = "/indicators/statistics/";
            break;
        case "RS":
            nexturl = "/indicators/remotesensing/";
            break;
        case "IRM":
        default:
            nexturl = "/indicators/meteo/";
            break;
    }
    window.open(nexturl, "_self");
};
export var onSelectReferencial = function (e) {
    currentReferencial = e.target.value;
    updateMapAndGraph();
};
export var onSelectTemporality = function (e) {
    // resetMapAndGraph();
    currentTemporality = e.target.value;
    initDecadeSelector();
    initMonthSelector();
    initDateSelector();
    initIndicatorSelect();
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
};
var onSelectYear = function (e) {
    // update date selector based on the year
    var year = Number(e.target.value);
    var dateInput = document.getElementById("dateInput");
    var currentDate = new Date(document.getElementById("dateInput").value);
    dateInput.value = new Date(currentDate.setFullYear(year))
        .toISOString()
        .split("T")[0];
    setYearSelectorValue();
    initDecadeSelector();
    initMonthSelector();
    /**
     * Update graph and map for the selected indicator
     */
    updateMapAndGraph();
    if (getCurrentProvider() != "STATBEL") {
        initCropSelector();
    }
};
function padLeadingZeros(num, size) {
    var s = num + "";
    while (s.length < size)
        s = "0" + s;
    return s;
}
/*
 * Reset general graph
 */
export var resetGeneralGraph = function () {
    itemGraph.classList.add("d-none");
    hideVariabilitySelector();
    // generalGraph.classList.remove("d-none");
    setCartoucheBox("");
    initYearSelector();
    initDecadeSelector();
    initMonthSelector();
    updateMapAndGraph();
};
// /*
//  * Reset map and graph
//  */
// const resetMapAndGraph = (): void => {
//   // reset messages boxes
//   setCartoucheBox("");
//   setMessageBox("");
//   hideLoaderBox();
//   setStatusBox("");
//   // reset popup
//   resetPopup();
//   // clear selected features
//   getSelectInteraction(map).getFeatures().clear();
//   // reset region agricole layer
//   if (raSource !== undefined) {
//     raSource.forEachFeature((f) => f.set("indicator", undefined));
//   }
//   // reset graph
//   resetGeneralGraph();
//   const graph = <HTMLElement>document.querySelector("div.panel__graph");
//   graph.innerHTML = "";
//   // reset current min and max
//   resetCurrentMinMax();
// };
var set1stJanuaryDateFromYear = function (year) {
    return new Date("01/01/".concat(year));
};
export var setCalendarDate = function (caldate) {
    /**
     * Set the value of the calendar to the provided caldate
     */
    var dateInput = document.getElementById("dateInput");
    dateInput.value = formatDateForInput(caldate);
    // griser toutes les valeurs supérieures (demandé pour meteo indicators)
    dateInput.max = formatDateForInput(caldate);
    return;
};
export var setCartoucheBox = function (content, mode) {
    if (mode === void 0) { mode = "text"; }
    var cartoucheDiv = (document.querySelector("div.panel__cartouche"));
    if (mode === "append") {
        /**
         * Use when passing a DOM object
         */
        cartoucheDiv.append(content);
    }
    else {
        /**
         * Use when passing text or html
         */
        cartoucheDiv.innerHTML = ESAPI.encoder().encodeForHTML(content);
    }
};
export var setCurrentRa = function (val) {
    currentRa = val;
};
export var setDecadeRangeValue = function () {
    var decadeInput = document.getElementById("decadeInput");
    var decade = Number(decadeInput.value);
    var output = document.getElementById("outputDecadeInput");
    // output.innerText = `${padLeadingZeros(decade, 2)} ${capitalize(formatReferenceDecade())}`;
    output.innerText = "".concat(capitalize(formatReferenceDecade()));
    var min = decadeInput.min ? Number(decadeInput.min) : 1;
    var max = decadeInput.max ? Number(decadeInput.max) : 36;
    var normalisedValue = Number((decade - min) / (max - min));
    output.style.left = "calc(".concat(normalisedValue, " * 17.5vw - 19.6vw)");
};
/**
 * Set the info box content
 * @param content - string
 */
export var setInfoBox = function (content) {
    var messageH3 = document.querySelector("h3.panel__info");
    messageH3.innerHTML = content;
    // messageH3.innerHTML = ESAPI.encoder().encodeForHTML(content);
};
/**
 * Set the message box content
 * @param content - string
 */
export var setMessageBox = function (content) {
    var messageP = document.querySelector("p.panel__message");
    messageP.innerHTML = content;
};
var setMonthRangeValue = function () {
    // const monthNames = ["jan", "fev", "mar", "avr", "mai", "jun",
    //     "jul", "aou", "sep", "oct", "nov", "dec"
    // ];
    var monthInput = document.getElementById("monthInput");
    var month = Number(monthInput.value);
    var output = document.getElementById("outputMonthInput");
    output.innerText = padLeadingZeros(month, 2);
    // output.innerText = monthNames[month - 1];
    // output.innerText = getCurrentDate().toLocaleString('default', { month: 'long' });
    var min = monthInput.min ? Number(monthInput.min) : 1;
    var max = monthInput.max ? Number(monthInput.max) : 12;
    var normalisedValue = Number((month - min) / (max - min));
    output.style.left = "calc(".concat(normalisedValue, " * 17.5vw - 19.6vw)");
};
/**
 * set reference date from a YYYY-mm-dd string
 */
export var setReferenceDate = function (date) {
    if (date !== undefined) {
        referenceDate = new Date(date);
    }
};
/**
 * Set the status message box
 */
export var setStatusBox = function (content) {
    var statusDiv = document.querySelector("h5.panel__status");
    statusDiv.innerHTML = ESAPI.encoder().encodeForHTML(content);
};
/**
 * Set the status message box
 */
export var statusContent = function () {
    return getCurrentProvider() === "IRM"
        ? currentTemporality === "MO"
            ? "".concat(getCurrentProvider(), " > ").concat(getCurrentTemporality(), " > ").concat(getCurrentIndicatorIRM(), " > ").concat(getCurrentYear(), " > ").concat(formatReferenceMonth())
            : currentTemporality === "DC"
                ? "".concat(getCurrentProvider(), " > ").concat(getCurrentTemporality(), " > ").concat(getCurrentIndicatorIRM(), " > ").concat(getCurrentYear(), " > ").concat(formatReferenceDecade())
                : "".concat(getCurrentProvider(), " > ").concat(getCurrentTemporality(), " > ").concat(getCurrentIndicatorIRM(), " > ").concat(getCurrentYear(), " > ").concat(formatReferenceMonthDay())
        : getCurrentProvider() === "RS"
            ? "".concat(getCurrentProvider(), " > ").concat(currentIndicator, " > ").concat(getCurrentYear(), " > ").concat(formatReferenceDecade())
            : "".concat(getCurrentProvider(), " > ").concat(currentIndicator, " > ").concat(getCurrentCropLabel(), " > ").concat(getCurrentYear());
}; // STATBEL;
var setYearMax = function (value) {
    if (getCurrentProvider() === "STATBEL") {
        (document.querySelector("div.year_range input#yearMax")).value = value.toString();
    }
};
export var setYearMin = function (value) {
    if (getCurrentProvider() === "STATBEL") {
        (document.querySelector("div.year_range input#yearMin")).value = value.toString();
    }
};
var setYearSelectorValue = function () {
    var yearInput = document.getElementById("yearInput");
    var year = Number(yearInput.value);
    var output = document.getElementById("outputYearInput");
    output.innerText = year.toString();
    var min = yearInput.min ? Number(yearInput.min) : 0;
    var max = yearInput.max ? Number(yearInput.max) : 100;
    var normalisedValue = Number((year - min) / (max - min));
    output.style.left = "calc(".concat(normalisedValue, " * 17.5vw - 20vw)");
    // output.style.left = `calc(${normalisedValue} * 17.5vw + 2.8vw)`;
};
var showCropSelector = function () {
    document.querySelector("div.crop_selector").classList.remove("d-none");
};
var showCultureSelector = function () {
    document.getElementById("cultureSelector").classList.remove("d-none");
};
var showDateSelector = function () {
    document.querySelector("div.date_selector").classList.remove("d-none");
};
var showDecadeSelector = function () {
    if (getCurrentProvider() === "IRM" || getCurrentProvider() === "RS") {
        (document.querySelector("div.decade_selector")).classList.remove("d-none");
    }
};
export var showLoaderBox = function () {
    var loaderBox = document.querySelector("div.panel__loader");
    loaderBox.classList.remove("d-none");
    var dataBadgeBox = document.querySelector("div.data-badge");
    dataBadgeBox.classList.add("d-none");
};
var showMonthSelector = function () {
    if (getCurrentProvider() === "IRM") {
        (document.querySelector("div.month_selector")).classList.remove("d-none");
    }
};
var showTemporalitySelector = function () {
    if (getCurrentProvider() === "IRM") {
        (document.querySelector("div.temporality_selector")).classList.remove("d-none");
    }
};
export var showVariabilitySelector = function () {
    if (getCurrentProvider() === "IRM" || getCurrentProvider() === "RS") {
        var vitems = document.querySelectorAll("div.variability_selector");
        vitems.forEach(function (item) {
            item.classList.remove("d-none");
        });
        //hide the referencial selector as it is not used
        (document.querySelector("div.referencial_selector")).classList.add("d-none");
    }
};
var showYearSelector = function () {
    document.querySelector("div.year_selector").classList.remove("d-none");
};
var showYearRange = function () {
    if (getCurrentProvider() === "STATBEL") {
        var yearRange = document.querySelector("div.year_range");
        yearRange.classList.remove("d-none");
    }
};
var updateMapAndGraph = function () {
    /**
     * Update graph and map for the selected indicator
     */
    if (currentIndicator === "") {
        wipeGraph();
    }
    else if (currentRa === "") {
        //reload belgium graph
        loadDataForMapAndGraph(currentIndicator);
    }
    else {
        // reload ra graph
        loadDataForItemGraph(currentIndicator, currentRa);
        loadDataForMap(currentIndicator);
    }
};
